// extracted by mini-css-extract-plugin
module.exports = {"Text":"HomeLoader_Text__3ADTY","loaderAnimation":"HomeLoader_loaderAnimation__1Az8g","Img":"HomeLoader_Img__2DRPj"};